import React, { Component } from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { Alert, Button, ButtonGroup, Card, CardBody } from 'reactstrap';
import { DateTime } from 'luxon';
import RouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';

import { modelOf } from '../../../prop-types';
import globalTranslations from '../../../i18n/globalTranslations';
import Token from '../../../models/Token';
import { parse } from '../../../util/queryString';

@observer
export class PaymentTokenList extends Component {
  getTokenizationMessage = () => {
    const tokenizationSuccess = parse(
      this.props.location.search
    ).tokenizationSuccess;

    if (!tokenizationSuccess) {
      return null;
    }
    const success = tokenizationSuccess === '1';
    return (
      <Alert color={success ? 'success' : 'danger'}>
        {success ? (
          <FormattedMessage
            id="tokens.createSuccessSentence"
            defaultMessage="Card added successfully."
          />
        ) : (
          <FormattedMessage
            id="tokens.createFailSentence"
            defaultMessage="Failed adding the payment card."
          />
        )}
      </Alert>
    );
  };

  renderTokenCard = (token) => {
    const { onRemoveClick, intl } = this.props;

    return (
      <Card className="PaymentTokenList__item" key={token.id} outline>
        <CardBody>
          <ButtonGroup className="PaymentTokenList__item-buttons">
            <Button
              onClick={() =>
                window.confirm(
                  intl.formatMessage(globalTranslations.confirmRemoveTitle)
                ) && onRemoveClick(token.id)
              }
              color="danger"
            >
              <FormattedMessage {...globalTranslations.removeTitle} />
            </Button>
          </ButtonGroup>
          <div className="PaymentTokenList__items">
            <div className="PaymentTokenList__item-title">{token.title}</div>
            <div className="PaymentTokenList__item-expired">
              {token.is_expired ? (
                <FormattedMessage
                  id="payment.expiredSentence"
                  defaultMessage="Expired"
                />
              ) : (
                <FormattedMessage
                  id="payment.validSentence"
                  defaultMessage="Valid"
                />
              )}
            </div>
            <div className="PaymentTokenList__item-created-at">
              <FormattedMessage
                id="payment.addedAtSentence"
                defaultMessage="Added on {createdAt}"
                values={{
                  createdAt: DateTime.fromISO(
                    token.created_at
                  ).toLocaleString(),
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>
    );
  };

  render() {
    const { tokens } = this.props;
    const tokenizationMessage = this.getTokenizationMessage();

    return (
      <div className="PaymentTokenList">
        {tokenizationMessage && (
          <div className="PaymentTokenList__tokenization-message">
            {tokenizationMessage}
          </div>
        )}
        {tokens.map((token) => this.renderTokenCard(token))}
      </div>
    );
  }
}

PaymentTokenList.propTypes = {
  onRemoveClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  location: RouterPropTypes.location.isRequired,
  tokens: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Token)),
    PropTypes.arrayOf(modelOf(Token)),
  ]),
};

export default withRouter(injectIntl(PaymentTokenList));
